export default {
  images: null,
  loading: false
}